// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"ArticlesLayout_mainContent__qwds0","separator":"ArticlesLayout_separator__wUDhf","darkTheme":"ArticlesLayout_darkTheme__2VfYx"};